// Styles
import { useStyles } from './styles/UsersHeader.styles';

// Components
import { Box, Button, IconButton, Link, OutlinedInput, Tooltip, Typography } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import ClearIcon from '@mui/icons-material/Clear';

// Consts, utils
import { AppRoutes } from '@consts/routes';

// Types
import type { useLocalStorage } from '@hooks/useLocalStorage';
import type { SearchInfo } from './types';

type UsersHeaderProps = {
    infoState: ReturnType<typeof useLocalStorage<SearchInfo>>;
};

export const UsersHeader = ({ infoState }: UsersHeaderProps) => {
    const [{ search, page }, setInfo, clearInfo] = infoState;

    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <Typography fontWeight='bold' variant='h2'>
                MO Insights Users
            </Typography>

            <OutlinedInput
                sx={{
                    minWidth: '200px',
                    flex: 1,
                }}
                id='input-with-icon-adornment'
                onChange={(e) => setInfo((prev) => ({ ...prev, search: e.target.value }))}
                value={search}
                inputProps={{
                    maxLength: 35,
                }}
                autoComplete='off'
                endAdornment={
                    <Tooltip arrow title='Clear search'>
                        <IconButton onClick={clearInfo} disabled={!search && page <= 1}>
                            <ClearIcon />
                        </IconButton>
                    </Tooltip>
                }
            />

            <Link component={RouterLink} to={AppRoutes.ManageUser}>
                <Button color='orange' variant='contained' startIcon={<AddIcon />}>
                    Add New User
                </Button>
            </Link>
        </Box>
    );
};
